import reducer from './reducer';

export default reducer;

// updating prettier to latest gives tremendous amount of errors
// moved to a separate PR
export { type ConsentsState } from './reducer';  // tslint:disable-line
export { getConsents, getUserConsents, updateUserConsent } from './actions';
